import { getClaimMagnetURL } from "apis/magnets";
import { useRouter } from "components/hooks";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { post } from "utils/request";
import { CurveArrow } from "components/atoms/Icon";
import moment from "moment";
import { email_regex } from "constants/constants";
import DynamicForm from "components/atoms/forms/DynamicForm";
import ClaimMagnetModal from "./ClaimMagnetModal";
import { TOAST_CONFIG } from "../../../constants";

export default function ClaimMagnetCTA({
  isCustomizedUIBrand = false,
  isCustomClaimForm,
  magnet_image_url,
  magnetName,
  magnetCreatedAt,
  formFields,
  claimText,
  onLoginAfterSubmit,
}: {
  isCustomizedUIBrand?: boolean;
  isCustomClaimForm: boolean;
  magnet_image_url: string;
  magnetName: string;
  magnetCreatedAt: any;
  formFields: DynamicFormField[];
  claimText?: string;
  onLoginAfterSubmit?: () => void;
}) {
  const router = useRouter();
  // TODO: use useForm hook and yup for validation.
  const [email, setEmail] = useState("");
  const [isUserNew, setIsUserNew] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [claimRequestStatus, setClaimRequestStatus] = useState("not-initiated");
  const [submitMessage, setSubmitMessage] = useState("");
  const [isSubmitDisabled, setIsSubmitDisabled] = React.useState(true);
  const { magnetId, eventId }: { magnetId: string; eventId: string } = router.query;
  const [isFormModalOpen, setIsFormModalOpen] = useState(false);

  const checkEmail = () => {
    setIsSubmitDisabled(!email_regex.test(email));
  };

  const handleSubmitFailure = (err: any) => {
    setSubmitMessage(err);
    setIsModalOpen(true);
    toast.error(err, TOAST_CONFIG);
    setClaimRequestStatus("failed");
    setIsFormModalOpen(false);
  };

  const handleSubmitSuccess = (resp: any) => {
    setClaimRequestStatus("successfull");
    setIsUserNew(resp.data.is_new_user);
    setIsModalOpen(true);
    setIsFormModalOpen(false);
  };

  const submitClaimRequest = async (userResponse: Object) => {
    setClaimRequestStatus("initiated");
    setIsSubmitDisabled(true);
    await post(
      getClaimMagnetURL(magnetId),
      {
        magnet_id: magnetId,
        event_id: eventId,
        form_response: userResponse,
      },
      {
        processData: handleSubmitSuccess,
        processError: handleSubmitFailure,
      },
    );
  };

  useEffect(() => {
    checkEmail();
  }, [email]);

  return (
    <>
      {isFormModalOpen && (
        <DynamicForm
          isCustomizedUIBrand={isCustomizedUIBrand}
          handleFormSubmit={submitClaimRequest}
          fields={formFields}
          onClose={() => setIsFormModalOpen(false)}
        />
      )}
      <ClaimMagnetModal
        isUserNew={isUserNew}
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
        }}
        submissionStatus={claimRequestStatus}
        errorMessage={submitMessage}
        onLoginAfterSubmit={onLoginAfterSubmit}
      />
      <figure
        style={{
          background: isCustomizedUIBrand
            ? "radial-gradient(circle, rgba(230,231,232,1) 0%, rgba(85,114,139,1) 56%, rgba(42,80,112,1) 100%)"
            : "black",
        }}
        className="mx-auto mt-8 flex max-w-md flex-col rounded-xl px-2 py-5 text-white shadow-modal md:mt-0 md:bg-opacity-50 md:px-7"
      >
        <div className=" font-satoshi md:hidden ">
          <div className="my-2 flex items-center space-x-2">
            <CurveArrow />
            <p className="text-white">
              {"Launched on "}
              {moment(magnetCreatedAt).format("MMMM D, YYYY")}
            </p>
          </div>

          <h1 className="text-xl font-bold md:text-3xl 2xl:text-5xl">{magnetName}</h1>
        </div>
        <img
          className="mt-4 max-h-[50vh] min-h-[350px] rounded-lg border-1 border-gray-300 bg-black object-cover outline-none focus:border-white"
          src={magnet_image_url}
          alt=""
        />
        <figcaption className="mt-12 flex flex-col">
          {!isCustomClaimForm ? (
            <>
              <form className="flex">
                <input
                  type="email"
                  placeholder="Enter email"
                  className="basis-3/4 rounded-s-full border-white bg-black py-3 pl-6 text-sm"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <button
                  disabled={eventId === undefined || isSubmitDisabled}
                  className="basis-1/4 rounded-e-full border-none bg-white text-xs font-bold text-[#060f1b] disabled:cursor-not-allowed disabled:bg-neutral-300 disabled:opacity-70"
                  onClick={(e) => {
                    e.preventDefault();
                    submitClaimRequest({ email });
                  }}
                  type="button"
                >
                  CLAIM
                </button>
              </form>
              <p className="w-full py-4 text-center text-xs ">Please provide your email to receive the Magnet.</p>
            </>
          ) : (
            <>
              <button
                type="button"
                disabled={eventId === undefined}
                style={{
                  background: isCustomizedUIBrand
                    ? "linear-gradient(129deg, rgba(132,37,114,1) 0%, rgba(42,80,112,1) 100%)"
                    : "white",
                  color: isCustomizedUIBrand ? "white" : "black",
                }}
                className="basis-1/4 rounded-full border-none py-4 text-xs font-bold text-white shadow-2xl disabled:cursor-not-allowed disabled:bg-neutral-300 disabled:opacity-70"
                onClick={() => setIsFormModalOpen(true)}
              >
                {isCustomClaimForm ? "ENROLL NOW" : "CLAIM NOW"}
              </button>
              <p className="w-full py-8 text-center text-xs">{claimText}</p>
            </>
          )}
        </figcaption>
      </figure>
    </>
  );
}
